export const API_SUGGESTIONS_NAME = 'ApiSuggestions';

export const API_END_POINTS = {
  FETCH_SUGGESTIONS: '/suggestions',
};



// WEBPACK FOOTER //
// ./app/sdk/suggestions/apiSuggestionsConstants.js